var _circle, _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    height: "128px",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    width: "128px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    fill: "#F0553A",
    r: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.674,93H64.17V36H41.674c1.864,8,10.044,19.299,15.711,25.49c1.637,1.791,1.631,3.712-0.009,5.5   C51.699,73.169,43.538,85,41.674,93z",
    fill: "#FFFFFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.17,93H39.999c-0.914,0-1.329,0.678-1.329,1.592v1.654c0,0.916,0.415,1.754,1.329,1.754H64.17V93z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.17,31H40.325c-0.914,0-1.655,0.74-1.655,1.654v1.691c0,0.914,0.741,1.654,1.655,1.654H64.17V31z",
    fill: "#FFFFFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.62,61.346C76.288,55.168,84.448,44,86.312,36H64.003v57h22.308c-1.863-8-10.043-19.623-15.703-25.816   C68.974,65.388,68.979,63.133,70.62,61.346z",
    fill: "#E4E8DC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.987,93H64.003v5h23.984c0.913,0,1.683-0.838,1.683-1.754v-1.654C89.67,93.677,88.9,93,87.987,93z",
    fill: "#E4E8DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.015,31H64.003v5h24.011c0.914,0,1.655-0.74,1.655-1.654v-1.691C89.67,31.74,88.929,31,88.015,31z",
    fill: "#E4E8DC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.402,76.347c-0.149-0.055-0.28-0.09-0.374-0.09c-1.884,0-12.207,8.531-16.764,16.664h17.138V76.347z",
    fill: "#EAD57D"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.014,92.921h16.708c-4.641-8.133-15.061-16.664-16.693-16.664c-0.004,0-0.01,0.002-0.014,0.002V92.921z    ",
    fill: "#D6C169"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.235,50h-9.254h-0.214H54.75c2.416,4.235,7.919,8.661,8.919,9.157v-0.103  c0,0.029,0.251-0.055,0.303-0.055c0.002,0-0.303,0-0.303,0v0.102C64.67,59.084,70.722,54.485,73.235,50z",
    fill: "#EAD57D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.971,50v9.012c1.543-0.586,6.924-4.837,9.264-9.012H63.971z",
    fill: "#D6C169"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4e9baa25b9e2990804f27eb3c1df7760.svg";
export { ForwardRef as ReactComponent };